module.exports = __webpack_public_path__ + "static/img/logo-03.02c9992.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-03.png
// module id = vCQK
// module chunks = 1